export const getVersion = (): string => {
  return import.meta.env.VITE_COMMIT_HASH || "dev-local";
};

export const getEnvironment = (): string => {
  return import.meta.env.VITE_ENVIRONMENT || "development";
};

export const isProduction = (): boolean => {
  const env = getEnvironment();
  return env === "production" || env === "prod";
};

export const shouldShowVersion = (): boolean => {
  return !isProduction();
};

const DEBUG_HOSTS = ["localhost", "127.0.0.1", "dev-platform.innovera.ai"];

export const isDebugEnvironment = (): boolean => DEBUG_HOSTS.includes(window.location.hostname);

export const getVersionDisplayText = (): string => {
  const version = getVersion();
  return version === "dev-local" ? "Development" : `${version.substring(0, 7)}`;
};
